<div style="display: flex; align-items: center; padding: 20px;">
  <span style="margin-right: 6px;">Voir en tant que : </span>
  <dx-select-box [width]="220" [dataSource]="utilisateurs" [(value)]="currentAsUserId"
    valueExpr="id" displayExpr="intitule" (onValueChanged)="changerAsUserId()" [searchEnabled]="true"
    [searchExpr]="['intitule']" [showClearButton]="true"
  ></dx-select-box>
</div>